import ControlTowerCreation, {
  useControlTowerCreation,
} from 'v3/components/ControlTowerCard/Creation';
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ApplicationLayout from 'v3/layouts/Application';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Space from 'v3/components/Space';
import { usePermission } from 'hooks';
import { Section } from '../shared/Section';
import { Data } from '../shared/Data';
import { useImplement } from '../shared/context';
import { handleCreation } from './controller';
import { OwnerData } from '../shared/Owner';

export function ImplementRegister() {
  const navigate = useNavigate();
  const implement = useImplement();
  const control = useControlTowerCreation('wagon');

  const [loading, setLoading] = useState(false);

  usePermission('CADASTRAR_IMPLEMENTO', {
    redirect: true,
  });

  return (
    <ApplicationLayout
      title="Cadastrar implemento"
      RightComponent={
        <Space x="0.5rem">
          <Button variant="secondary" onClick={() => navigate('/implementos')}>
            <Text color="dark" weight={500}>
              Voltar
            </Text>
          </Button>
          <Button
            variant="primary"
            loading={loading || control.busy}
            onClick={async () => {
              const id = await control.submit(() =>
                handleCreation(
                  implement.data,
                  implement.setData,
                  implement.setErrors,
                  implement.showSnackbar,
                  setLoading,
                  navigate,
                  true,
                ),
              );
              if (id) {
                implement.showSnackbar('Implemento e disponibilidade salvos.', {
                  type: 'success',
                });
                navigate(`/implementos/${id}`);
              }
            }}
          >
            <Text color="white" weight={500}>
              Salvar
            </Text>
          </Button>
        </Space>
      }
    >
      <fieldset
        inert={!!control.createdId}
        disabled={loading || control.busy || !!control.createdId}
        style={{ border: 0, padding: 0 }}
      >
        <Row>
          <Col xs={12} md={6}>
            <Section Title="Dados do implemento">
              <Data />
            </Section>
          </Col>
          <Col xs={12} md={6}>
            <Section Title="Proprietário">
              <OwnerData />
            </Section>
          </Col>
        </Row>
      </fieldset>
      <ControlTowerCreation control={control} />
    </ApplicationLayout>
  );
}
